module.exports = __webpack_public_path__ + "static/media/trade_returns.b8744df1.png";